export default __webpack_public_path__ + "static/media/mousee_shield.3f2aa21c.png";